<template>
  <v-layout :title="$t('about_global_store.title')">
    <b-container fluid class="mt-5">
      <b-row>
        <b-col
          cols="12"
          md="6"
          order="2"
          order-md="1"
          class="pl-3 pl-md-0"
        >
          <b-row
            v-for="(feature, index) in features"
            :key="index"
            class="mb-5"
          >
            <b-col
              cols="1"
              class="text-center p-0 m-0"
              align-self="center"
            >
              <component v-bind:is="feature.icon"></component>
            </b-col>
            <b-col cols="11" class="feature">
              <p class="text-uppercase heading mb-1">
                {{ $t(feature.titleKey) }}
              </p>
              <p>
                {{ $t(feature.descriptionKey) }}
              </p>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          cols="12"
          md="6"
          order="1"
          order-md="2"
          class="text-right mt-2 mb-5"
        >
          <img src="@/static/about/que-es-medika.png" class="w-100" />
        </b-col>
      </b-row>
    </b-container>

    <div class="section mt-5">
      <div class="heading text-uppercase mb-3">
        {{ $t("about_global_store.how_shopping_title") }}
      </div>
      <div class="text-uppercase mb-5">
        {{ $t("about_global_store.how_shopping_description") }}
      </div>
      <b-container fluid class="p-0">
        <b-row>
          <b-col
            v-for="(step, index) in shopping_steps"
            :key="index"
            cols="12"
            md="3"
            class="text-center mb-3"
          >
            <component
              v-bind:is="step.icon"
              class="mb-4"
            ></component>
            <div class="number mb-2">
              {{ $t(step.titleKey) }}
            </div>
            <div>
              {{ $t(step.descriptionKey) }}
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <div class="section mt-5">
      <div class="heading text-uppercase mb-3">
        {{ $t("about_global_store.pharmacies_title") }}
      </div>
      <div>
        {{ $t("about_global_store.pharmacies_description") }}<br />
        <router-link
          :to="{ name: 'listpharmacies' }"
          class="pharmacy-list"
        >
          {{ $t("about_global_store.pharmacies_check") }}
        </router-link>
      </div>
    </div>

    <div class="section mt-5">
      <div class="heading text-uppercase mb-3">
        {{ $t("about_global_store.shipping_costs_title") }}
      </div>
      <p>
        {{ $t("about_global_store.shipping_costs_description1") }}
      </p>
      <p class="small">
        {{ $t("about_global_store.shipping_costs_description2") }}
      </p>
      <p class="small">
        {{ $t("about_global_store.shipping_costs_description3") }}
      </p>
    </div>

    <div class="section mt-5">
      <div class="heading text-uppercase mb-3">
        {{ $t("about_global_store.direct_delivery") }}
      </div>
      <p>
        {{ $t("about_global_store.direct_delivery_description") }}
      </p>
    </div>

    <b-container fluid class="mt-5">
      <b-row>
        <b-col
          v-for="(process, index) in processes"
          :key="index"
          cols="3"
          class="text-center m-0 p-0"
        >
          <component
            v-bind:is="process.icon"
            class="mb-2"
          ></component>
          <div class="process w-50 mx-auto">
            {{ $t(process.descriptionKey) }}
          </div>
        </b-col>
      </b-row>
      <b-row class="my-5">
        <b-col
          v-for="(process, index) in processes"
          :key="index"
          cols="3"
          class="text-right p-0"
          v-bind:style="{ 'background-color': process.color }"
        >
          <img :src="process.arrow" />
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid class="p-0 py-5">
      <b-row class="section mt-3">
        <b-col cols="12" md="6">
          <div class="small-heading text-uppercase mb-3">
            {{ $t("about_global_store.savings_title") }}
          </div>
          <p>
            {{ $t("about_global_store.savings_description") }}
          </p>
        </b-col>
        <b-col cols="12" md="6">
          <div class="small-heading text-uppercase mb-3">
            {{ $t("about_global_store.prices_title") }}
          </div>
          <p>
            {{ $t("about_global_store.prices_description") }}
          </p>
        </b-col>
      </b-row>
    </b-container>
  </v-layout>
</template>


<script>
import VLayout from "@/layouts/Default";

import SVGDirect from "@/static/about/ic_directo.svg";
import SVGProducts from "@/static/about/ic_30000.svg";
import SVGSuper from "@/static/about/ic_super.svg";
import SVGMobile from "@/static/about/ic_en_tu_movil.svg";
import SVGStep1 from "@/static/about/ic_1.svg";
import SVGStep2 from "@/static/about/ic_2.svg";
import SVGStep3 from "@/static/about/ic_3.svg";
import SVGStep4 from "@/static/about/ic_4.svg";
import SVGProcess1 from "@/static/about/ic_realizar_el_pedido.svg";
import SVGProcess2 from "@/static/about/ic_repartidor.svg";
import SVGProcess3 from "@/static/about/ic_farmacia.svg";
import SVGProcess4 from "@/static/about/ic_entrega.svg";

export default {
  components: {
    VLayout,
  },
  data() {
    return {
      features: [
        {
          titleKey: "about_global_store.direct_title",
          descriptionKey: "about_global_store.direct_description",
          icon: SVGDirect,
        },
        {
          titleKey: "about_global_store.products_title",
          descriptionKey: "about_global_store.products_description",
          icon: SVGProducts,
        },
        {
          titleKey: "about_global_store.super_title",
          descriptionKey: "about_global_store.super_description",
          icon: SVGSuper,
        },
        {
          titleKey: "about_global_store.mobile_title",
          descriptionKey: "about_global_store.mobile_description",
          icon: SVGMobile,
        },
      ],
      shopping_steps: [
        {
          titleKey: "about_global_store.step1_title",
          descriptionKey: "about_global_store.step1_description",
          icon: SVGStep1,
        },
        {
          titleKey: "about_global_store.step2_title",
          descriptionKey: "about_global_store.step2_description",
          icon: SVGStep2,
        },
        {
          titleKey: "about_global_store.step3_title",
          descriptionKey: "about_global_store.step3_description",
          icon: SVGStep3,
        },
        {
          titleKey: "about_global_store.step4_title",
          descriptionKey: "about_global_store.step4_description",
          icon: SVGStep4,
        },
      ],
      processes: [
        {
          descriptionKey: "about_global_store.process1",
          icon: SVGProcess1,
          arrow: require("@/static/about/quees_arrow_1.png"),
          color: "#8dc63f",
        },
        {
          descriptionKey: "about_global_store.process2",
          icon: SVGProcess2,
          arrow: require("@/static/about/quees_arrow_2.png"),
          color: "#26854f",
        },
        {
          descriptionKey: "about_global_store.process3",
          icon: SVGProcess3,
          arrow: require("@/static/about/quees_arrow_3.png"),
          color: "#408ac7",
        },
        {
          descriptionKey: "about_global_store.process4",
          icon: SVGProcess4,
          color: "#fe5e00",
        },
      ],
    };
  },
  fallbackI18n: {
    messages: {
      und: {
        about_global_store: {
          title: "Your pharmacy online",
          breadcrumb: "What is Vooy Market.?",
          direct_title: "Direct from pharmacies",
          direct_description:
            "Purchase online directly from pharmacies in Mexico, with confidence and quality in their products.",
          products_title: "12,500+ health products",
          products_description:
            "On Vooy Market you'll find a complete catalogue with products for health, beauty, hygiene, babies and much more.",
          super_title: "Super Promos",
          super_description:
            "Discover offers and exclusive promotions and keep track of the best online prices. Don't miss them!",
          mobile_title: "In your smartphone",
          mobile_description:
            "Bring with you the App of Vooy Market to keep an eye on the latest products we have for you.",
          how_shopping_title: "How to make my shopping?",
          how_shopping_description: "Your purchase, step by step",
          step1_title: "1st",
          step1_description:
            "Use the browser or navigate on the Website to find the product you were looking for",
          step2_title: "2nd",
          step2_description: "Select your products and add them to your cart",
          step3_title: "3rd",
          step3_description:
            "Enter your shipping address and confirm the payment",
          step4_title: "4th",
          step4_description:
            "The pharmacy prepares your order and delivers it to you in 24 hours",
          pharmacies_title: "Which pharmacies sell in Vooy Market.?",
          pharmacies_description:
            "Buy directly from the pharmacies established online in Mexico and receive the products at your home.",
          pharmacies_check: "Check the pharmacies here",
          shipping_costs_title: "Shipping costs",
          shipping_costs_description1:
            "After placing your order, confirm the delivery time, it may vary depending on your address. Delivery within the Mexican Republic from 24 to 48 hours *. Shipping costs will always appear broken down in the shopping cart, you can choose the delivery company of your liking before completing the order.",
          shipping_costs_description2:
            "(*) Deliveries of the product are only made on business days (No deliveries on Saturdays, Sundays or holidays). The processing of orders made after 4:00 pm will be carried out the following day and will take effect that same day.",
          shipping_costs_description3:
            "In the cases of payment by bank transfer or convenience store the delivery period will begin from the effective confirmation of the payment by sending the correspondent bank receipt.",
          direct_delivery: "Home delivery directly from the pharmacy",
          direct_delivery_description:
            "There is the option of choosing the home delivery direct service from the nearest Pharmacy to your address. If the pharmacy has your order in stock the delivery date will be the same day *. In case of not having the complete order, it will be delivered from 24 to 48 hours *. In any case, the selected store will always contact you to manage the delivery.",
          process1: "Make the order on Vooy Market",
          process2: "The deliverer receives your order",
          process3: "The pharmacy prepares your order",
          process4: "It delivers your order at your address",
          savings_title: "How the savings in the prices are calculated?",
          savings_description:
            "The savings are calculated by making the difference between the Recommended Retail Price and the final price. vooymarket.com compare between all the Recommended Retail Prices from all the laboratories and also takes account of the price indicated by the IMS (pharmacies average price indicator). Pharmacies put an online price directly so you can enjoy a great selection.",
          prices_title: "Why the prices may change in the cart?",
          prices_description:
            "This is because it makes a combination in the shopping cart in order to seek for savings in your shopping, thus, the prices may be adjusted for the sake of your economy.",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.feature {
  font-size: $font-size-medium;

  .heading {
    font-size: $font-size-medium * 1.1;
    font-weight: bold;
  }
}

.section {
  font-size: $font-size-base * 1.1;

  .heading {
    font-size: $font-size-medium * 1.5;
  }

  .small-heading {
    font-size: $font-size-medium * 1.3;
  }
}

.number {
  font-size: $font-size-medium * 1.1;
  font-weight: bold;
}

.pharmacy-list {
  text-decoration: underline;
}

.process {
  font-size: $font-size-base * 1.1;
}
</style>
